import AuditLogs from '@pages/Admin/pages/AuditLogs/index';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import AppLayout from '@pages/_layout/AppLayout';

export default [
  {
    path: 'audit-logs',
    element: <AppLayout />,
    children: [{ index: true, element: <AuditLogs /> }],
  },
] as RouteObject[];
